"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = [{
    "name": "北京",
    "city": [{
        "name": "北京",
        "area": ["東城區", "西城區", "崇文區", "宣武區", "朝陽區", "豐臺區", "石景山區", "海澱區", "門頭溝區", "房山區", "通州區", "順義區", "昌平區", "大興區", "平穀區", "懷柔區", "密雲縣", "延慶縣"]
    }]
}, {
    "name": "天津",
    "city": [{
        "name": "天津",
        "area": ["和平區", "河東區", "河西區", "南開區", "河北區", "紅橋區", "塘沽區", "漢沽區", "大港區", "東麗區", "西青區", "津南區", "北辰區", "武清區", "寶坻區", "寧河縣", "靜海縣", "薊縣"]
    }]
}, {
    "name": "河北",
    "city": [{
        "name": "石家莊",
        "area": ["長安區", "橋東區", "橋西區", "新華區", "郊區", "井陘礦區", "井陘縣", "正定縣", "欒城縣", "行唐縣", "靈壽縣", "高邑縣", "深澤縣", "贊皇縣", "無極縣", "平山縣", "元氏縣", "趙縣", "辛集市", "槁", "晉州市", "新樂市", "鹿泉市"]
    }, {
        "name": "唐山",
        "area": ["路南區", "路北區", "古冶區", "開平區", "新區", "豐潤縣", "灤縣", "灤南縣", "樂亭縣", "遷西縣", "玉田縣", "唐海縣", "遵化市", "豐南市", "遷安市"]
    }, {
        "name": "秦皇島",
        "area": ["海港區", "山海關區", "北戴河區", "青龍滿族自治縣", "昌黎縣", "撫寧縣", "盧龍縣"]
    }, {
        "name": "邯鄲",
        "area": ["邯山區", "叢臺區", "復興區", "峰峰礦區", "邯鄲縣", "臨漳縣", "成安縣", "大名縣", "涉縣", "磁縣", "肥鄉縣", "永年縣", "邱縣", "雞澤縣", "廣平縣", "館陶縣", "魏縣", "曲周縣", "武安市"]
    }, {
        "name": "邢臺",
        "area": ["橋東區", "橋西區", "邢臺縣", "臨城縣", "內丘縣", "柏鄉縣", "隆堯縣", "任縣", "南和縣", "寧晉縣", "巨鹿縣", "新河縣", "廣宗縣", "平鄉縣", "威縣", "清河縣", "臨西縣", "南宮市", "沙河市"]
    }, {
        "name": "保定",
        "area": ["新市區", "北市區", "南市區", "滿城縣", "清苑縣", "淶水縣", "阜平縣", "徐水縣", "定興縣", "唐縣", "高陽縣", "容城縣", "淶源縣", "望都縣", "安新縣", "易縣", "曲陽縣", "蠡縣", "順平縣", "博野", "雄縣", "涿州市", "定州市", "安國市", "高碑店市"]
    }, {
        "name": "張家口",
        "area": ["橋東區", "橋西區", "宣化區", "下花園區", "宣化縣", "張北縣", "康保縣", "沽源縣", "尚義縣", "蔚縣", "陽原縣", "懷安縣", "萬全縣", "懷來縣", "涿鹿縣", "赤城縣", "崇禮縣"]
    }, {
        "name": "承德",
        "area": ["雙橋區", "雙灤區", "鷹手營子礦區", "承德縣", "興隆縣", "平泉縣", "灤平縣", "隆化縣", "豐寧滿族自治縣", "寬城滿族自治縣", "圍場滿族蒙古族自治縣"]
    }, {
        "name": "滄州",
        "area": ["新華區", "運河區", "滄縣", "青縣", "東光縣", "海興縣", "鹽山縣", "肅寧縣", "南皮縣", "吳橋縣", "獻縣", "孟村回族自治縣", "泊頭市", "任丘市", "黃驊市", "河間市"]
    }, {
        "name": "廊坊",
        "area": ["安次區", "固安縣", "永清縣", "香河縣", "大城縣", "文安縣", "大廠回族自治縣", "霸州市", "三河市"]
    }, {
        "name": "衡水",
        "area": ["桃城區", "棗強縣", "武邑縣", "武強縣", "饒陽縣", "安平縣", "故城縣", "景縣", "阜城縣", "冀州市", "深州市"]
    }]
}, {
    "name": "山西",
    "city": [{
        "name": "太原",
        "area": ["小店區", "迎澤區", "杏花嶺區", "尖草坪區", "萬柏林區", "晉源區", "清徐縣", "陽曲縣", "婁煩縣", "古交市"]
    }, {
        "name": "大同",
        "area": ["城區", "礦區", "南郊區", "新榮區", "陽高縣", "天鎮縣", "廣靈縣", "靈丘縣", "渾源縣", "左雲縣", "大同縣"]
    }, {
        "name": "陽泉",
        "area": ["城區", "礦區", "郊區", "平定縣", "盂縣"]
    }, {
        "name": "長治",
        "area": ["城區", "郊區", "長治縣", "襄垣縣", "屯留縣", "平順縣", "黎城縣", "壺關縣", "長子縣", "武鄉縣", "沁縣", "沁源縣", "潞城市"]
    }, {
        "name": "晉城",
        "area": ["城區", "沁水縣", "陽城縣", "陵川縣", "澤州縣", "高平市"]
    }, {
        "name": "朔州",
        "area": ["朔城區", "平魯區", "山陰縣", "應縣", "右玉縣", "懷仁縣"]
    }, {
        "name": "忻州",
        "area": ["忻府區", "原平市", "定襄縣", "五臺縣", "代縣", "繁峙縣", "寧武縣", "靜樂縣", "神池縣", "五寨縣", "岢嵐縣", "河曲縣", "保德縣", "偏關縣"]
    }, {
        "name": "呂梁",
        "area": ["離石區", "孝義市", "汾陽市", "文水縣", "交城縣", "興縣", "臨縣", "柳林縣", "石樓縣", "嵐縣", "方山縣", "中陽縣", "交口縣"]
    }, {
        "name": "晉中",
        "area": ["榆次市", "介休市", "榆社縣", "左權縣", "和順縣", "昔陽縣", "壽陽縣", "太穀縣", "祁縣", "平遙縣", "靈石縣"]
    }, {
        "name": "臨汾",
        "area": ["臨汾市", "侯馬市", "霍州市", "曲沃縣", "翼城縣", "襄汾縣", "洪洞縣", "古縣", "安澤縣", "浮山縣", "吉縣", "鄉寧縣", "蒲縣", "大寧縣", "永和縣", "隰縣", "汾西縣"]
    }, {
        "name": "運城",
        "area": ["運城市", "永濟市", "河津市", "芮城縣", "臨猗縣", "萬榮縣", "新絳縣", "稷山縣", "聞喜縣", "夏縣", "絳縣", "平陸縣", "垣曲縣"]
    }]
}, {
    "name": "內蒙古",
    "city": [{
        "name": "呼和浩特",
        "area": ["新城區", "回民區", "玉泉區", "郊區", "土默特左旗", "托克托縣", "和林格爾縣", "清水河縣", "武川縣"]
    }, {
        "name": "包頭",
        "area": ["東河區", "昆都倫區", "青山區", "石拐礦區", "白雲礦區", "郊區", "土默特右旗", "固陽縣", "達爾罕茂明安聯合旗"]
    }, {
        "name": "烏海",
        "area": ["海勃灣區", "海南區", "烏達區"]
    }, {
        "name": "赤峰",
        "area": ["紅山區", "元寶山區", "松山區", "阿魯科爾沁旗", "巴林左旗", "巴林右旗", "林西縣", "克什克騰旗", "翁牛特旗", "喀喇沁旗", "寧城縣", "敖漢旗"]
    }, {
        "name": "呼倫貝爾",
        "area": ["海拉爾市", "滿洲里市", "紮蘭屯市", "牙克石市", "根河市", "額爾古納市", "阿榮旗", "莫力達瓦達斡爾族自治旗", "鄂倫春自治旗", "鄂溫克族自治旗", "新巴爾虎右旗", "新巴爾虎左旗", "陳巴爾虎旗"]
    }, {
        "name": "興安盟",
        "area": ["烏蘭浩特市", "阿爾山市", "科爾沁右翼前旗", "科爾沁右翼中旗", "紮賚特旗", "突泉縣"]
    }, {
        "name": "通遼",
        "area": ["科爾沁區", "霍林郭勒市", "科爾沁左翼中旗", "科爾沁左翼後旗", "開魯縣", "庫倫旗", "奈曼旗", "紮魯特旗"]
    }, {
        "name": "錫林郭勒盟",
        "area": ["二連浩特市", "錫林浩特市", "阿巴嘎旗", "蘇尼特左旗", "蘇尼特右旗", "東烏珠穆沁旗", "西烏珠穆沁旗", "太僕寺旗", "鑲黃旗", "正鑲白旗", "正藍旗", "多倫縣"]
    }, {
        "name": "烏蘭察布盟",
        "area": ["集寧市", "豐鎮市", "卓資縣", "化德縣", "商都縣", "興和縣", "涼城縣", "察哈爾右翼前旗", "察哈爾右翼中旗", "察哈爾右翼後旗", "四子王旗"]
    }, {
        "name": "伊克昭盟",
        "area": ["東勝市", "達拉特旗", "准格爾旗", "鄂托克前旗", "鄂托克旗", "杭錦旗", "烏審旗", "伊金霍洛旗"]
    }, {
        "name": "巴彥淖爾盟",
        "area": ["臨河市", "五原縣", "磴口縣", "烏拉特前旗", "烏拉特中旗", "烏拉特後旗", "杭錦後旗"]
    }, {
        "name": "阿拉善盟",
        "area": ["阿拉善左旗", "阿拉善右旗", "額濟納旗"]
    }]
}, {
    "name": "遼寧",
    "city": [{
        "name": "瀋陽",
        "area": ["沈河區", "皇姑區", "和平區", "大東區", "鐵西區", "蘇家屯區", "東陵區", "於洪區", "新民市", "法庫縣", "遼中縣", "康平縣", "新城子區", "其他"]
    }, {
        "name": "大連",
        "area": ["西崗區", "中山區", "沙河口區", "甘井子區", "旅順口區", "金州區", "瓦房店市", "普蘭店市", "莊河市", "長海縣", "其他"]
    }, {
        "name": "鞍山",
        "area": ["鐵東區", "鐵西區", "立山區", "千山區", "海城市", "臺安縣", "岫岩滿族自治縣", "其他"]
    }, {
        "name": "撫順",
        "area": ["順城區", "新撫區", "東洲區", "望花區", "撫順縣", "清原滿族自治縣", "新賓滿族自治縣", "其他"]
    }, {
        "name": "本溪",
        "area": ["平山區", "明山區", "溪湖區", "南芬區", "本溪滿族自治縣", "桓仁滿族自治縣", "其他"]
    }, {
        "name": "丹東",
        "area": ["振興區", "元寶區", "振安區", "東港市", "鳳城市", "寬甸滿族自治縣", "其他"]
    }, {
        "name": "錦州",
        "area": ["太和區", "古塔區", "淩河區", "淩海市", "黑山縣", "義縣", "北寧市", "其他"]
    }, {
        "name": "營口",
        "area": ["站前區", "西市區", "鮁魚圈區", "老邊區", "大石橋市", "蓋州市", "其他"]
    }, {
        "name": "阜新",
        "area": ["海州區", "新邱區", "太平區", "清河門區", "細河區", "彰武縣", "阜新蒙古族自治縣", "其他"]
    }, {
        "name": "遼陽",
        "area": ["白塔區", "文聖區", "宏偉區", "太子河區", "弓長嶺區", "燈塔市", "遼陽縣", "其他"]
    }, {
        "name": "盤錦",
        "area": ["雙臺子區", "興隆臺區", "盤山縣", "大窪縣", "其他"]
    }, {
        "name": "鐵嶺",
        "area": ["銀州區", "清河區", "調兵山市", "開原市", "鐵嶺縣", "昌圖縣", "西豐縣", "其他"]
    }, {
        "name": "朝陽",
        "area": ["雙塔區", "龍城區", "淩源市", "北票市", "朝陽縣", "建平縣", "喀喇沁左翼蒙古族自治縣", "其他"]
    }, {
        "name": "葫蘆島",
        "area": ["龍港區", "南票區", "連山區", "興城市", "綏中縣", "建昌縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "吉林",
    "city": [{
        "name": "長春",
        "area": ["朝陽區", "寬城區", "二道區", "南關區", "綠園區", "雙陽區", "九臺市", "榆樹市", "德惠市", "農安縣", "其他"]
    }, {
        "name": "吉林",
        "area": ["船營區", "昌邑區", "龍潭區", "豐滿區", "舒蘭市", "樺甸市", "蛟河市", "磐石市", "永吉縣", "其他"]
    }, {
        "name": "四平",
        "area": ["鐵西區", "鐵東區", "公主嶺市", "雙遼市", "梨樹縣", "伊通滿族自治縣", "其他"]
    }, {
        "name": "遼源",
        "area": ["龍山區", "西安區", "東遼縣", "東豐縣", "其他"]
    }, {
        "name": "通化",
        "area": ["東昌區", "二道江區", "梅河口市", "集安市", "通化縣", "輝南縣", "柳河縣", "其他"]
    }, {
        "name": "白山",
        "area": ["八道江區", "江源區", "臨江市", "靖宇縣", "撫松縣", "長白朝鮮族自治縣", "其他"]
    }, {
        "name": "松原",
        "area": ["寧江區", "乾安縣", "長嶺縣", "扶餘縣", "前郭爾羅斯蒙古族自治縣", "其他"]
    }, {
        "name": "白城",
        "area": ["洮北區", "大安市", "洮南市", "鎮賚縣", "通榆縣", "其他"]
    }, {
        "name": "延邊朝鮮族自治州",
        "area": ["延吉市", "圖們市", "敦化市", "龍井市", "琿春市", "和龍市", "安圖縣", "汪清縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "黑龍江",
    "city": [{
        "name": "哈爾濱",
        "area": ["松北區", "道裏區", "南崗區", "平房區", "香坊區", "道外區", "呼蘭區", "阿城區", "雙城市", "尚志市", "五常市", "賓縣", "方正縣", "通河縣", "巴彥縣", "延壽縣", "木蘭縣", "依蘭縣", "其他"]
    }, {
        "name": "齊齊哈爾",
        "area": ["龍沙區", "昂昂溪區", "鐵鋒區", "建華區", "富拉爾基區", "碾子山區", "梅裏斯達斡爾族區", "訥河市", "富裕縣", "拜泉縣", "甘南縣", "依安縣", "克山縣", "泰來縣", "克東縣", "龍江縣", "其他"]
    }, {
        "name": "鶴崗",
        "area": ["興山區", "工農區", "南山區", "興安區", "向陽區", "東山區", "蘿北縣", "綏濱縣", "其他"]
    }, {
        "name": "雙鴨山",
        "area": ["尖山區", "嶺東區", "四方臺區", "寶山區", "集賢縣", "寶清縣", "友誼縣", "饒河縣", "其他"]
    }, {
        "name": "雞西",
        "area": ["雞冠區", "恒山區", "城子河區", "滴道區", "梨樹區", "麻山區", "密山市", "虎林市", "雞東縣", "其他"]
    }, {
        "name": "大慶",
        "area": ["薩爾圖區", "紅崗區", "龍鳳區", "讓胡路區", "大同區", "林甸縣", "肇州縣", "肇源縣", "杜爾伯特蒙古族自治縣", "其他"]
    }, {
        "name": "伊春",
        "area": ["伊春區", "帶嶺區", "南岔區", "金山屯區", "西林區", "美溪區", "烏馬河區", "翠巒區", "友好區", "上甘嶺區", "五營區", "紅星區", "新青區", "湯旺河區", "烏伊嶺區", "鐵力市", "嘉蔭縣", "其他"]
    }, {
        "name": "牡丹江",
        "area": ["愛民區", "東安區", "陽明區", "西安區", "綏芬河市", "寧安市", "海林市", "穆棱市", "林口縣", "東寧縣", "其他"]
    }, {
        "name": "佳木斯",
        "area": ["向陽區", "前進區", "東風區", "郊區", "同江市", "富錦市", "樺川縣", "撫遠縣", "樺南縣", "湯原縣", "其他"]
    }, {
        "name": "七臺河",
        "area": ["桃山區", "新興區", "茄子河區", "勃利縣", "其他"]
    }, {
        "name": "黑河",
        "area": ["愛輝區", "北安市", "五大連池市", "遜克縣", "嫩江縣", "孫吳縣", "其他"]
    }, {
        "name": "綏化",
        "area": ["北林區", "安達市", "肇東市", "海倫市", "綏棱縣", "蘭西縣", "明水縣", "青岡縣", "慶安縣", "望奎縣", "其他"]
    }, {
        "name": "大興安嶺地區",
        "area": ["呼瑪縣", "塔河縣", "漠河縣", "大興安嶺轄區", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "上海",
    "city": [{
        "name": "上海",
        "area": ["黃浦區", "盧灣區", "徐匯區", "長寧區", "靜安區", "普陀區", "閘北區", "虹口區", "楊浦區", "寶山區", "閔行區", "嘉定區", "松江區", "金山區", "青浦區", "南匯區", "奉賢區", "浦東新區", "崇明縣", "其他"]
    }]
}, {
    "name": "江蘇",
    "city": [{
        "name": "南京",
        "area": ["玄武區", "白下區", "秦淮區", "建鄴區", "鼓樓區", "下關區", "棲霞區", "雨花台區", "浦口區", "江寧區", "六合區", "溧水縣", "高淳縣", "其他"]
    }, {
        "name": "蘇州",
        "area": ["金閶區", "平江區", "滄浪區", "虎丘區", "吳中區", "相城區", "常熟市", "張家港市", "昆山市", "吳江市", "太倉市", "其他"]
    }, {
        "name": "無錫",
        "area": ["崇安區", "南長區", "北塘區", "濱湖區", "錫山區", "惠山區", "江陰市", "宜興市", "其他"]
    }, {
        "name": "常州",
        "area": ["鐘樓區", "天寧區", "戚墅堰區", "新北區", "武進區", "金壇市", "溧陽市", "其他"]
    }, {
        "name": "鎮江",
        "area": ["京口區", "潤州區", "丹徒區", "丹陽市", "揚中市", "句容市", "其他"]
    }, {
        "name": "南通",
        "area": ["崇川區", "港閘區", "通州市", "如皋市", "海門市", "啟東市", "海安縣", "如東縣", "其他"]
    }, {
        "name": "泰州",
        "area": ["海陵區", "高港區", "薑堰市", "泰興市", "靖江市", "興化市", "其他"]
    }, {
        "name": "揚州",
        "area": ["廣陵區", "維揚區", "邗江區", "江都市", "儀征市", "高郵市", "寶應縣", "其他"]
    }, {
        "name": "鹽城",
        "area": ["亭湖區", "鹽都區", "大豐市", "東臺市", "建湖縣", "射陽縣", "阜寧縣", "濱海縣", "響水縣", "其他"]
    }, {
        "name": "連雲港",
        "area": ["新浦區", "海州區", "連雲區", "東海縣", "灌雲縣", "贛榆縣", "灌南縣", "其他"]
    }, {
        "name": "徐州",
        "area": ["雲龍區", "鼓樓區", "九裏區", "泉山區", "賈汪區", "邳州市", "新沂市", "銅山縣", "睢寧縣", "沛縣", "豐縣", "其他"]
    }, {
        "name": "淮安",
        "area": ["清河區", "清浦區", "楚州區", "淮陰區", "漣水縣", "洪澤縣", "金湖縣", "盱眙縣", "其他"]
    }, {
        "name": "宿遷",
        "area": ["宿城區", "宿豫區", "沭陽縣", "泗陽縣", "泗洪縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "浙江",
    "city": [{
        "name": "杭州",
        "area": ["拱墅區", "西湖區", "上城區", "下城區", "江幹區", "濱江區", "餘杭區", "蕭山區", "建德市", "富陽市", "臨安市", "桐廬縣", "淳安縣", "其他"]
    }, {
        "name": "寧波",
        "area": ["海曙區", "江東區", "江北區", "鎮海區", "北侖區", "鄞州區", "餘姚市", "慈溪市", "奉化市", "寧海縣", "象山縣", "其他"]
    }, {
        "name": "溫州",
        "area": ["鹿城區", "龍灣區", "甌海區", "瑞安市", "樂清市", "永嘉縣", "洞頭縣", "平陽縣", "蒼南縣", "文成縣", "泰順縣", "其他"]
    }, {
        "name": "嘉興",
        "area": ["秀城區", "秀洲區", "海寧市", "平湖市", "桐鄉市", "嘉善縣", "海鹽縣", "其他"]
    }, {
        "name": "湖州",
        "area": ["吳興區", "南潯區", "長興縣", "德清縣", "安吉縣", "其他"]
    }, {
        "name": "紹興",
        "area": ["越城區", "諸暨市", "上虞市", "嵊州市", "紹興縣", "新昌縣", "其他"]
    }, {
        "name": "金華",
        "area": ["婺城區", "金東區", "蘭溪市", "義烏市", "東陽市", "永康市", "武義縣", "浦江縣", "磐安縣", "其他"]
    }, {
        "name": "衢州",
        "area": ["柯城區", "衢江區", "江山市", "龍遊縣", "常山縣", "開化縣", "其他"]
    }, {
        "name": "舟山",
        "area": ["定海區", "普陀區", "岱山縣", "嵊泗縣", "其他"]
    }, {
        "name": "臺州",
        "area": ["椒江區", "黃岩區", "路橋區", "臨海市", "溫嶺市", "玉環縣", "天臺縣", "仙居縣", "三門縣", "其他"]
    }, {
        "name": "麗水",
        "area": ["蓮都區", "龍泉市", "縉雲縣", "青田縣", "雲和縣", "遂昌縣", "松陽縣", "慶元縣", "景寧佘族自治縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "安徽",
    "city": [{
        "name": "合肥",
        "area": ["廬陽區", "瑤海區", "蜀山區", "包河區", "長豐縣", "肥東縣", "肥西縣", "其他"]
    }, {
        "name": "蕪湖",
        "area": ["鏡湖區", "弋江區", "鳩江區", "三山區", "蕪湖縣", "南陵縣", "繁昌縣", "其他"]
    }, {
        "name": "蚌埠",
        "area": ["蚌山區", "龍子湖區", "禹會區", "淮上區", "懷遠縣", "固鎮縣", "五河縣", "其他"]
    }, {
        "name": "淮南",
        "area": ["田家庵區", "大通區", "謝家集區", "八公山區", "潘集區", "鳳臺縣", "其他"]
    }, {
        "name": "馬鞍山",
        "area": ["雨山區", "花山區", "金家莊區", "當塗縣", "其他"]
    }, {
        "name": "淮北",
        "area": ["相山區", "杜集區", "烈山區", "濉溪縣", "其他"]
    }, {
        "name": "銅陵",
        "area": ["銅官山區", "獅子山區", "郊區", "銅陵縣", "其他"]
    }, {
        "name": "安慶",
        "area": ["迎江區", "大觀區", "宜秀區", "桐城市", "宿松縣", "樅陽縣", "太湖縣", "懷寧縣", "嶽西縣", "望江縣", "潛山縣", "其他"]
    }, {
        "name": "黃山",
        "area": ["屯溪區", "黃山區", "徽州區", "休寧縣", "歙縣", "祁門縣", "黟縣", "其他"]
    }, {
        "name": "滁州",
        "area": ["琅琊區", "南譙區", "天長市", "明光市", "全椒縣", "來安縣", "定遠縣", "鳳陽縣", "其他"]
    }, {
        "name": "阜陽",
        "area": ["潁州區", "潁東區", "潁泉區", "界首市", "臨泉縣", "潁上縣", "阜南縣", "太和縣", "其他"]
    }, {
        "name": "宿州",
        "area": ["埇橋區", "蕭縣", "泗縣", "碭山縣", "靈璧縣", "其他"]
    }, {
        "name": "巢湖",
        "area": ["居巢區", "含山縣", "無為縣", "廬江縣", "和縣", "其他"]
    }, {
        "name": "六安",
        "area": ["金安區", "裕安區", "壽縣", "霍山縣", "霍邱縣", "舒城縣", "金寨縣", "其他"]
    }, {
        "name": "亳州",
        "area": ["譙城區", "利辛縣", "渦陽縣", "蒙城縣", "其他"]
    }, {
        "name": "池州",
        "area": ["貴池區", "東至縣", "石臺縣", "青陽縣", "其他"]
    }, {
        "name": "宣城",
        "area": ["宣州區", "寧國市", "廣德縣", "郎溪縣", "涇縣", "旌德縣", "績溪縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "福建",
    "city": [{
        "name": "福州",
        "area": ["鼓樓區", "臺江區", "倉山區", "馬尾區", "晉安區", "福清市", "長樂市", "閩侯縣", "閩清縣", "永泰縣", "連江縣", "羅源縣", "平潭縣", "其他"]
    }, {
        "name": "廈門",
        "area": ["思明區", "海滄區", "湖裏區", "集美區", "同安區", "翔安區", "其他"]
    }, {
        "name": "莆田",
        "area": ["城廂區", "涵江區", "荔城區", "秀嶼區", "仙遊縣", "其他"]
    }, {
        "name": "三明",
        "area": ["梅列區", "三元區", "永安市", "明溪縣", "將樂縣", "大田縣", "寧化縣", "建寧縣", "沙縣", "尤溪縣", "清流縣", "泰寧縣", "其他"]
    }, {
        "name": "泉州",
        "area": ["鯉城區", "豐澤區", "洛江區", "泉港區", "石獅市", "晉江市", "南安市", "惠安縣", "永春縣", "安溪縣", "德化縣", "金門縣", "其他"]
    }, {
        "name": "漳州",
        "area": ["薌城區", "龍文區", "龍海市", "平和縣", "南靖縣", "詔安縣", "漳浦縣", "華安縣", "東山縣", "長泰縣", "雲霄縣", "其他"]
    }, {
        "name": "南平",
        "area": ["延平區", "建甌市", "邵武市", "武夷山市", "建陽市", "松溪縣", "光澤縣", "順昌縣", "浦城縣", "政和縣", "其他"]
    }, {
        "name": "龍岩",
        "area": ["新羅區", "漳平市", "長汀縣", "武平縣", "上杭縣", "永定縣", "連城縣", "其他"]
    }, {
        "name": "寧德",
        "area": ["蕉城區", "福安市", "福鼎市", "壽寧縣", "霞浦縣", "柘榮縣", "屏南縣", "古田縣", "周寧縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "江西",
    "city": [{
        "name": "南昌",
        "area": ["東湖區", "西湖區", "青雲譜區", "灣裏區", "青山湖區", "新建縣", "南昌縣", "進賢縣", "安義縣", "其他"]
    }, {
        "name": "景德鎮",
        "area": ["珠山區", "昌江區", "樂平市", "浮梁縣", "其他"]
    }, {
        "name": "萍鄉",
        "area": ["安源區", "湘東區", "蓮花縣", "上栗縣", "蘆溪縣", "其他"]
    }, {
        "name": "九江",
        "area": ["潯陽區", "廬山區", "瑞昌市", "九江縣", "星子縣", "武寧縣", "彭澤縣", "永修縣", "修水縣", "湖口縣", "德安縣", "都昌縣", "其他"]
    }, {
        "name": "新餘",
        "area": ["渝水區", "分宜縣", "其他"]
    }, {
        "name": "鷹潭",
        "area": ["月湖區", "貴溪市", "餘江縣", "其他"]
    }, {
        "name": "贛州",
        "area": ["章貢區", "瑞金市", "南康市", "石城縣", "安遠縣", "贛縣", "寧都縣", "尋烏縣", "興國縣", "定南縣", "上猶縣", "於都縣", "龍南縣", "崇義縣", "信豐縣", "全南縣", "大餘縣", "會昌縣", "其他"]
    }, {
        "name": "吉安",
        "area": ["吉州區", "青原區", "井岡山市", "吉安縣", "永豐縣", "永新縣", "新幹縣", "泰和縣", "峽江縣", "遂川縣", "安福縣", "吉水縣", "萬安縣", "其他"]
    }, {
        "name": "宜春",
        "area": ["袁州區", "豐城市", "樟樹市", "高安市", "銅鼓縣", "靖安縣", "宜豐縣", "奉新縣", "萬載縣", "上高縣", "其他"]
    }, {
        "name": "撫州",
        "area": ["臨川區", "南豐縣", "樂安縣", "金溪縣", "南城縣", "東鄉縣", "資溪縣", "宜黃縣", "廣昌縣", "黎川縣", "崇仁縣", "其他"]
    }, {
        "name": "上饒",
        "area": ["信州區", "德興市", "上饒縣", "廣豐縣", "鄱陽縣", "婺源縣", "鉛山縣", "餘幹縣", "橫峰縣", "弋陽縣", "玉山縣", "萬年縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "山東",
    "city": [{
        "name": "濟南",
        "area": ["市中區", "曆下區", "天橋區", "槐蔭區", "曆城區", "長清區", "章丘市", "平陰縣", "濟陽縣", "商河縣", "其他"]
    }, {
        "name": "青島",
        "area": ["市南區", "市北區", "城陽區", "四方區", "李滄區", "黃島區", "嶗山區", "膠南市", "膠州市", "平度市", "萊西市", "即墨市", "其他"]
    }, {
        "name": "淄博",
        "area": ["張店區", "臨淄區", "淄川區", "博山區", "周村區", "桓臺縣", "高青縣", "沂源縣", "其他"]
    }, {
        "name": "棗莊",
        "area": ["市中區", "山亭區", "嶧城區", "臺兒莊區", "薛城區", "滕州市", "其他"]
    }, {
        "name": "東營",
        "area": ["東營區", "河口區", "墾利縣", "廣饒縣", "利津縣", "其他"]
    }, {
        "name": "煙臺",
        "area": ["芝罘區", "福山區", "牟平區", "萊山區", "龍口市", "萊陽市", "萊州市", "招遠市", "蓬萊市", "棲霞市", "海陽市", "長島縣", "其他"]
    }, {
        "name": "濰坊",
        "area": ["濰城區", "寒亭區", "坊子區", "奎文區", "青州市", "諸城市", "壽光市", "安丘市", "高密市", "昌邑市", "昌樂縣", "臨朐縣", "其他"]
    }, {
        "name": "濟寧",
        "area": ["市中區", "任城區", "曲阜市", "兗州市", "鄒城市", "魚臺縣", "金鄉縣", "嘉祥縣", "微山縣", "汶上縣", "泗水縣", "梁山縣", "其他"]
    }, {
        "name": "泰安",
        "area": ["泰山區", "岱嶽區", "新泰市", "肥城市", "寧陽縣", "東平縣", "其他"]
    }, {
        "name": "威海",
        "area": ["環翠區", "乳山市", "文登市", "榮成市", "其他"]
    }, {
        "name": "日照",
        "area": ["東港區", "嵐山區", "五蓮縣", "莒縣", "其他"]
    }, {
        "name": "萊蕪",
        "area": ["萊城區", "鋼城區", "其他"]
    }, {
        "name": "臨沂",
        "area": ["蘭山區", "羅莊區", "河東區", "沂南縣", "郯城縣", "沂水縣", "蒼山縣", "費縣", "平邑縣", "莒南縣", "蒙陰縣", "臨沭縣", "其他"]
    }, {
        "name": "德州",
        "area": ["德城區", "樂陵市", "禹城市", "陵縣", "寧津縣", "齊河縣", "武城縣", "慶雲縣", "平原縣", "夏津縣", "臨邑縣", "其他"]
    }, {
        "name": "聊城",
        "area": ["東昌府區", "臨清市", "高唐縣", "陽穀縣", "茌平縣", "莘縣", "東阿縣", "冠縣", "其他"]
    }, {
        "name": "濱州",
        "area": ["濱城區", "鄒平縣", "沾化縣", "惠民縣", "博興縣", "陽信縣", "無棣縣", "其他"]
    }, {
        "name": "菏澤",
        "area": ["牡丹區", "鄄城縣", "單縣", "鄆城縣", "曹縣", "定陶縣", "巨野縣", "東明縣", "成武縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "河南",
    "city": [{
        "name": "鄭州",
        "area": ["中原區", "金水區", "二七區", "管城回族區", "上街區", "惠濟區", "鞏義市", "新鄭市", "新密市", "登封市", "滎陽市", "中牟縣", "其他"]
    }, {
        "name": "開封",
        "area": ["鼓樓區", "龍亭區", "順河回族區", "禹王臺區", "金明區", "開封縣", "尉氏縣", "蘭考縣", "杞縣", "通許縣", "其他"]
    }, {
        "name": "洛陽",
        "area": ["西工區", "老城區", "澗西區", "瀍河回族區", "洛龍區", "吉利區", "偃師市", "孟津縣", "汝陽縣", "伊川縣", "洛寧縣", "嵩縣", "宜陽縣", "新安縣", "欒川縣", "其他"]
    }, {
        "name": "平頂山",
        "area": ["新華區", "衛東區", "湛河區", "石龍區", "汝州市", "舞鋼市", "寶豐縣", "葉縣", "郟縣", "魯山縣", "其他"]
    }, {
        "name": "安陽",
        "area": ["北關區", "文峰區", "殷都區", "龍安區", "林州市", "安陽縣", "滑縣", "內黃縣", "湯陰縣", "其他"]
    }, {
        "name": "鶴壁",
        "area": ["淇濱區", "山城區", "鶴山區", "浚縣", "淇縣", "其他"]
    }, {
        "name": "新鄉",
        "area": ["衛濱區", "紅旗區", "鳳泉區", "牧野區", "衛輝市", "輝縣市", "新鄉縣", "獲嘉縣", "原陽縣", "長垣縣", "封丘縣", "延津縣", "其他"]
    }, {
        "name": "焦作",
        "area": ["解放區", "中站區", "馬村區", "山陽區", "沁陽市", "孟州市", "修武縣", "溫縣", "武陟縣", "博愛縣", "其他"]
    }, {
        "name": "濮陽",
        "area": ["華龍區", "濮陽縣", "南樂縣", "臺前縣", "清豐縣", "範縣", "其他"]
    }, {
        "name": "許昌",
        "area": ["魏都區", "禹州市", "長葛市", "許昌縣", "鄢陵縣", "襄城縣", "其他"]
    }, {
        "name": "漯河",
        "area": ["源匯區", "郾城區", "召陵區", "臨潁縣", "舞陽縣", "其他"]
    }, {
        "name": "三門峽",
        "area": ["湖濱區", "義馬市", "靈寶市", "澠池縣", "盧氏縣", "陝縣", "其他"]
    }, {
        "name": "南陽",
        "area": ["臥龍區", "宛城區", "鄧州市", "桐柏縣", "方城縣", "淅川縣", "鎮平縣", "唐河縣", "南召縣", "內鄉縣", "新野縣", "社旗縣", "西峽縣", "其他"]
    }, {
        "name": "商丘",
        "area": ["梁園區", "睢陽區", "永城市", "寧陵縣", "虞城縣", "民權縣", "夏邑縣", "柘城縣", "睢縣", "其他"]
    }, {
        "name": "信陽",
        "area": ["浉河區", "平橋區", "潢川縣", "淮濱縣", "息縣", "新縣", "商城縣", "固始縣", "羅山縣", "光山縣", "其他"]
    }, {
        "name": "周口",
        "area": ["川匯區", "項城市", "商水縣", "淮陽縣", "太康縣", "鹿邑縣", "西華縣", "扶溝縣", "沈丘縣", "鄲城縣", "其他"]
    }, {
        "name": "駐馬店",
        "area": ["驛城區", "確山縣", "新蔡縣", "上蔡縣", "西平縣", "泌陽縣", "平輿縣", "汝南縣", "遂平縣", "正陽縣", "其他"]
    }, {
        "name": "焦作",
        "area": ["濟源市", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "湖北",
    "city": [{
        "name": "武漢",
        "area": ["江岸區", "武昌區", "江漢區", "硚口區", "漢陽區", "青山區", "洪山區", "東西湖區", "漢南區", "蔡甸區", "江夏區", "黃陂區", "新洲區", "其他"]
    }, {
        "name": "黃石",
        "area": ["黃石港區", "西塞山區", "下陸區", "鐵山區", "大冶市", "陽新縣", "其他"]
    }, {
        "name": "十堰",
        "area": ["張灣區", "茅箭區", "丹江口市", "鄖縣", "竹山縣", "房縣", "鄖西縣", "竹溪縣", "其他"]
    }, {
        "name": "荊州",
        "area": ["沙市區", "荊州區", "洪湖市", "石首市", "松滋市", "監利縣", "公安縣", "江陵縣", "其他"]
    }, {
        "name": "宜昌",
        "area": ["西陵區", "伍家崗區", "點軍區", "猇亭區", "夷陵區", "宜都市", "當陽市", "枝江市", "秭歸縣", "遠安縣", "興山縣", "五峰土家族自治縣", "長陽土家族自治縣", "其他"]
    }, {
        "name": "襄樊",
        "area": ["襄城區", "樊城區", "襄陽區", "老河口市", "棗陽市", "宜城市", "南漳縣", "穀城縣", "保康縣", "其他"]
    }, {
        "name": "鄂州",
        "area": ["鄂城區", "華容區", "梁子湖區", "其他"]
    }, {
        "name": "荊門",
        "area": ["東寶區", "掇刀區", "鐘祥市", "京山縣", "沙洋縣", "其他"]
    }, {
        "name": "孝感",
        "area": ["孝南區", "應城市", "安陸市", "漢川市", "雲夢縣", "大悟縣", "孝昌縣", "其他"]
    }, {
        "name": "黃岡",
        "area": ["黃州區", "麻城市", "武穴市", "紅安縣", "羅田縣", "浠水縣", "蘄春縣", "黃梅縣", "英山縣", "團風縣", "其他"]
    }, {
        "name": "鹹寧",
        "area": ["鹹安區", "赤壁市", "嘉魚縣", "通山縣", "崇陽縣", "通城縣", "其他"]
    }, {
        "name": "隨州",
        "area": ["曾都區", "廣水市", "其他"]
    }, {
        "name": "恩施土家族苗族自治州",
        "area": ["恩施市", "利川市", "建始縣", "來鳳縣", "巴東縣", "鶴峰縣", "宣恩縣", "鹹豐縣", "其他"]
    }, {
        "name": "仙桃",
        "area": ["仙桃"]
    }, {
        "name": "天門",
        "area": ["天門"]
    }, {
        "name": "潛江",
        "area": ["潛江"]
    }, {
        "name": "神農架林區",
        "area": ["神農架林區"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "湖南",
    "city": [{
        "name": "長沙",
        "area": ["嶽麓區", "芙蓉區", "天心區", "開福區", "雨花區", "瀏陽市", "長沙縣", "望城縣", "寧鄉縣", "其他"]
    }, {
        "name": "株洲",
        "area": ["天元區", "荷塘區", "蘆淞區", "石峰區", "醴陵市", "株洲縣", "炎陵縣", "茶陵縣", "攸縣", "其他"]
    }, {
        "name": "湘潭",
        "area": ["嶽塘區", "雨湖區", "湘鄉市", "韶山市", "湘潭縣", "其他"]
    }, {
        "name": "衡陽",
        "area": ["雁峰區", "珠暉區", "石鼓區", "蒸湘區", "南嶽區", "耒陽市", "常寧市", "衡陽縣", "衡東縣", "衡山縣", "衡南縣", "祁東縣", "其他"]
    }, {
        "name": "邵陽",
        "area": ["雙清區", "大祥區", "北塔區", "武岡市", "邵東縣", "洞口縣", "新邵縣", "綏寧縣", "新寧縣", "邵陽縣", "隆回縣", "城步苗族自治縣", "其他"]
    }, {
        "name": "岳陽",
        "area": ["岳陽樓區", "雲溪區", "君山區", "臨湘市", "汨羅市", "岳陽縣", "湘陰縣", "平江縣", "華容縣", "其他"]
    }, {
        "name": "常德",
        "area": ["武陵區", "鼎城區", "津市市", "澧縣", "臨澧縣", "桃源縣", "漢壽縣", "安鄉縣", "石門縣", "其他"]
    }, {
        "name": "張家界",
        "area": ["永定區", "武陵源區", "慈利縣", "桑植縣", "其他"]
    }, {
        "name": "益陽",
        "area": ["赫山區", "資陽區", "沅江市", "桃江縣", "南縣", "安化縣", "其他"]
    }, {
        "name": "郴州",
        "area": ["北湖區", "蘇仙區", "資興市", "宜章縣", "汝城縣", "安仁縣", "嘉禾縣", "臨武縣", "桂東縣", "永興縣", "桂陽縣", "其他"]
    }, {
        "name": "永州",
        "area": ["冷水灘區", "零陵區", "祁陽縣", "藍山縣", "寧遠縣", "新田縣", "東安縣", "江永縣", "道縣", "雙牌縣", "江華瑤族自治縣", "其他"]
    }, {
        "name": "懷化",
        "area": ["鶴城區", "洪江市", "會同縣", "沅陵縣", "辰溪縣", "漵浦縣", "中方縣", "新晃侗族自治縣", "芷江侗族自治縣", "通道侗族自治縣", "靖州苗族侗族自治縣", "麻陽苗族自治縣", "其他"]
    }, {
        "name": "婁底",
        "area": ["婁星區", "冷水江市", "漣源市", "新化縣", "雙峰縣", "其他"]
    }, {
        "name": "湘西土家族苗族自治州",
        "area": ["吉首市", "古丈縣", "龍山縣", "永順縣", "鳳凰縣", "瀘溪縣", "保靖縣", "花垣縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "廣東",
    "city": [{
        "name": "廣州",
        "area": ["越秀區", "荔灣區", "海珠區", "天河區", "白雲區", "黃埔區", "番禺區", "花都區", "南沙區", "蘿崗區", "增城市", "從化市", "其他"]
    }, {
        "name": "深圳",
        "area": ["福田區", "羅湖區", "南山區", "寶安區", "龍崗區", "鹽田區", "其他"]
    }, {
        "name": "東莞",
        "area": ["莞城", "常平", "塘廈", "塘廈", "塘廈", "其他"]
    }, {
        "name": "中山",
        "area": ["中山"]
    }, {
        "name": "潮州",
        "area": ["湘橋區", "潮安縣", "饒平縣", "其他"]
    }, {
        "name": "揭陽",
        "area": ["榕城區", "揭東縣", "揭西縣", "惠來縣", "普寧市", "其他"]
    }, {
        "name": "雲浮",
        "area": ["雲城區", "新興縣", "鬱南縣", "雲安縣", "羅定市", "其他"]
    }, {
        "name": "珠海",
        "area": ["香洲區", "斗門區", "金灣區", "其他"]
    }, {
        "name": "汕頭",
        "area": ["金平區", "濠江區", "龍湖區", "潮陽區", "潮南區", "澄海區", "南澳縣", "其他"]
    }, {
        "name": "韶關",
        "area": ["湞江區", "武江區", "曲江區", "樂昌市", "南雄市", "始興縣", "仁化縣", "翁源縣", "新豐縣", "乳源瑤族自治縣", "其他"]
    }, {
        "name": "佛山",
        "area": ["禪城區", "南海區", "順德區", "三水區", "高明區", "其他"]
    }, {
        "name": "江門",
        "area": ["蓬江區", "江海區", "新會區", "恩平市", "臺山市", "開平市", "鶴山市", "其他"]
    }, {
        "name": "湛江",
        "area": ["赤坎區", "霞山區", "坡頭區", "麻章區", "吳川市", "廉江市", "雷州市", "遂溪縣", "徐聞縣", "其他"]
    }, {
        "name": "茂名",
        "area": ["茂南區", "茂港區", "化州市", "信宜市", "高州市", "電白縣", "其他"]
    }, {
        "name": "肇慶",
        "area": ["端州區", "鼎湖區", "高要市", "四會市", "廣寧縣", "懷集縣", "封開縣", "德慶縣", "其他"]
    }, {
        "name": "惠州",
        "area": ["惠城區", "惠陽區", "博羅縣", "惠東縣", "龍門縣", "其他"]
    }, {
        "name": "梅州",
        "area": ["梅江區", "興寧市", "梅縣", "大埔縣", "豐順縣", "五華縣", "平遠縣", "蕉嶺縣", "其他"]
    }, {
        "name": "汕尾",
        "area": ["城區", "陸豐市", "海豐縣", "陸河縣", "其他"]
    }, {
        "name": "河源",
        "area": ["源城區", "紫金縣", "龍川縣", "連平縣", "和平縣", "東源縣", "其他"]
    }, {
        "name": "陽江",
        "area": ["江城區", "陽春市", "陽西縣", "陽東縣", "其他"]
    }, {
        "name": "清遠",
        "area": ["清城區", "英德市", "連州市", "佛岡縣", "陽山縣", "清新縣", "連山壯族瑤族自治縣", "連南瑤族自治縣", "其他"]
    }]
}, {
    "name": "廣西",
    "city": [{
        "name": "南寧",
        "area": ["青秀區", "興寧區", "西鄉塘區", "良慶區", "江南區", "邕寧區", "武鳴縣", "隆安縣", "馬山縣", "上林縣", "賓陽縣", "橫縣", "其他"]
    }, {
        "name": "柳州",
        "area": ["城中區", "魚峰區", "柳北區", "柳南區", "柳江縣", "柳城縣", "鹿寨縣", "融安縣", "融水苗族自治縣", "三江侗族自治縣", "其他"]
    }, {
        "name": "桂林",
        "area": ["象山區", "秀峰區", "疊彩區", "七星區", "雁山區", "陽朔縣", "臨桂縣", "靈川縣", "全州縣", "平樂縣", "興安縣", "灌陽縣", "荔浦縣", "資源縣", "永福縣", "龍勝各族自治縣", "恭城瑤族自治縣", "其他"]
    }, {
        "name": "梧州",
        "area": ["萬秀區", "蝶山區", "長洲區", "岑溪市", "蒼梧縣", "藤縣", "蒙山縣", "其他"]
    }, {
        "name": "北海",
        "area": ["海城區", "銀海區", "鐵山港區", "合浦縣", "其他"]
    }, {
        "name": "防城港",
        "area": ["港口區", "防城區", "東興市", "上思縣", "其他"]
    }, {
        "name": "欽州",
        "area": ["欽南區", "欽北區", "靈山縣", "浦北縣", "其他"]
    }, {
        "name": "貴港",
        "area": ["港北區", "港南區", "覃塘區", "桂平市", "平南縣", "其他"]
    }, {
        "name": "玉林",
        "area": ["玉州區", "北流市", "容縣", "陸川縣", "博白縣", "興業縣", "其他"]
    }, {
        "name": "百色",
        "area": ["右江區", "淩雲縣", "平果縣", "西林縣", "樂業縣", "德保縣", "田林縣", "田陽縣", "靖西縣", "田東縣", "那坡縣", "隆林各族自治縣", "其他"]
    }, {
        "name": "賀州",
        "area": ["八步區", "鐘山縣", "昭平縣", "富川瑤族自治縣", "其他"]
    }, {
        "name": "河池",
        "area": ["金城江區", "宜州市", "天峨縣", "鳳山縣", "南丹縣", "東蘭縣", "都安瑤族自治縣", "羅城仫佬族自治縣", "巴馬瑤族自治縣", "環江毛南族自治縣", "大化瑤族自治縣", "其他"]
    }, {
        "name": "來賓",
        "area": ["興賓區", "合山市", "象州縣", "武宣縣", "忻城縣", "金秀瑤族自治縣", "其他"]
    }, {
        "name": "崇左",
        "area": ["江州區", "憑祥市", "寧明縣", "扶綏縣", "龍州縣", "大新縣", "天等縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "海南",
    "city": [{
        "name": "海口",
        "area": ["龍華區", "秀英區", "瓊山區", "美蘭區", "其他"]
    }, {
        "name": "三亞",
        "area": ["三亞市", "其他"]
    }, {
        "name": "五指山",
        "area": ["五指山"]
    }, {
        "name": "瓊海",
        "area": ["瓊海"]
    }, {
        "name": "儋州",
        "area": ["儋州"]
    }, {
        "name": "文昌",
        "area": ["文昌"]
    }, {
        "name": "萬寧",
        "area": ["萬寧"]
    }, {
        "name": "東方",
        "area": ["東方"]
    }, {
        "name": "澄邁縣",
        "area": ["澄邁縣"]
    }, {
        "name": "定安縣",
        "area": ["定安縣"]
    }, {
        "name": "屯昌縣",
        "area": ["屯昌縣"]
    }, {
        "name": "臨高縣",
        "area": ["臨高縣"]
    }, {
        "name": "白沙黎族自治縣",
        "area": ["白沙黎族自治縣"]
    }, {
        "name": "昌江黎族自治縣",
        "area": ["昌江黎族自治縣"]
    }, {
        "name": "樂東黎族自治縣",
        "area": ["樂東黎族自治縣"]
    }, {
        "name": "陵水黎族自治縣",
        "area": ["陵水黎族自治縣"]
    }, {
        "name": "保亭黎族苗族自治縣",
        "area": ["保亭黎族苗族自治縣"]
    }, {
        "name": "瓊中黎族苗族自治縣",
        "area": ["瓊中黎族苗族自治縣"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "重慶",
    "city": [{
        "name": "重慶",
        "area": ["渝中區", "大渡口區", "江北區", "南岸區", "北碚區", "渝北區", "巴南區", "長壽區", "雙橋區", "沙坪壩區", "萬盛區", "萬州區", "涪陵區", "黔江區", "永川區", "合川區", "江津區", "九龍坡區", "南川區", "綦江縣", "潼南縣", "榮昌縣", "璧山縣", "大足縣", "銅梁縣", "梁平縣", "開縣", "忠縣", "城口縣", "墊江縣", "武隆縣", "豐都縣", "奉節縣", "雲陽縣", "巫溪縣", "巫山縣", "石柱土家族自治縣", "秀山土家族苗族自治縣", "酉陽土家族苗族自治縣", "彭水苗族土家族自治縣", "其他"]
    }]
}, {
    "name": "四川",
    "city": [{
        "name": "成都",
        "area": ["青羊區", "錦江區", "金牛區", "武侯區", "成華區", "龍泉驛區", "青白江區", "新都區", "溫江區", "都江堰市", "彭州市", "邛崍市", "崇州市", "金堂縣", "郫縣", "新津縣", "雙流縣", "蒲江縣", "大邑縣", "其他"]
    }, {
        "name": "自貢",
        "area": ["大安區", "自流井區", "貢井區", "沿灘區", "榮縣", "富順縣", "其他"]
    }, {
        "name": "攀枝花",
        "area": ["仁和區", "米易縣", "鹽邊縣", "東區", "西區", "其他"]
    }, {
        "name": "瀘州",
        "area": ["江陽區", "納溪區", "龍馬潭區", "瀘縣", "合江縣", "敘永縣", "古藺縣", "其他"]
    }, {
        "name": "德陽",
        "area": ["旌陽區", "廣漢市", "什邡市", "綿竹市", "羅江縣", "中江縣", "其他"]
    }, {
        "name": "綿陽",
        "area": ["涪城區", "遊仙區", "江油市", "鹽亭縣", "三臺縣", "平武縣", "安縣", "梓潼縣", "北川羌族自治縣", "其他"]
    }, {
        "name": "廣元",
        "area": ["元壩區", "朝天區", "青川縣", "旺蒼縣", "劍閣縣", "蒼溪縣", "市中區", "其他"]
    }, {
        "name": "遂寧",
        "area": ["船山區", "安居區", "射洪縣", "蓬溪縣", "大英縣", "其他"]
    }, {
        "name": "內江",
        "area": ["市中區", "東興區", "資中縣", "隆昌縣", "威遠縣", "其他"]
    }, {
        "name": "樂山",
        "area": ["市中區", "五通橋區", "沙灣區", "金口河區", "峨眉山市", "夾江縣", "井研縣", "犍為縣", "沐川縣", "馬邊彝族自治縣", "峨邊彝族自治縣", "其他"]
    }, {
        "name": "南充",
        "area": ["順慶區", "高坪區", "嘉陵區", "閬中市", "營山縣", "蓬安縣", "儀隴縣", "南部縣", "西充縣", "其他"]
    }, {
        "name": "眉山",
        "area": ["東坡區", "仁壽縣", "彭山縣", "洪雅縣", "丹棱縣", "青神縣", "其他"]
    }, {
        "name": "宜賓",
        "area": ["翠屏區", "宜賓縣", "興文縣", "南溪縣", "珙縣", "長寧縣", "高縣", "江安縣", "筠連縣", "屏山縣", "其他"]
    }, {
        "name": "廣安",
        "area": ["廣安區", "華鎣市", "嶽池縣", "鄰水縣", "武勝縣", "其他"]
    }, {
        "name": "達州",
        "area": ["通川區", "萬源市", "達縣", "渠縣", "宣漢縣", "開江縣", "大竹縣", "其他"]
    }, {
        "name": "雅安",
        "area": ["雨城區", "蘆山縣", "石棉縣", "名山縣", "天全縣", "滎經縣", "寶興縣", "漢源縣", "其他"]
    }, {
        "name": "巴中",
        "area": ["巴州區", "南江縣", "平昌縣", "通江縣", "其他"]
    }, {
        "name": "資陽",
        "area": ["雁江區", "簡陽市", "安嶽縣", "樂至縣", "其他"]
    }, {
        "name": "阿壩藏族羌族自治州",
        "area": ["馬爾康縣", "九寨溝縣", "紅原縣", "汶川縣", "阿壩縣", "理縣", "若爾蓋縣", "小金縣", "黑水縣", "金川縣", "松潘縣", "壤塘縣", "茂縣", "其他"]
    }, {
        "name": "甘孜藏族自治州",
        "area": ["康定縣", "丹巴縣", "爐霍縣", "九龍縣", "甘孜縣", "雅江縣", "新龍縣", "道孚縣", "白玉縣", "理塘縣", "德格縣", "鄉城縣", "石渠縣", "稻城縣", "色達縣", "巴塘縣", "瀘定縣", "得榮縣", "其他"]
    }, {
        "name": "涼山彝族自治州",
        "area": ["西昌市", "美姑縣", "昭覺縣", "金陽縣", "甘洛縣", "布拖縣", "雷波縣", "普格縣", "寧南縣", "喜德縣", "會東縣", "越西縣", "會理縣", "鹽源縣", "德昌縣", "冕寧縣", "木裏藏族自治縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "貴州",
    "city": [{
        "name": "貴陽",
        "area": ["南明區", "雲岩區", "花溪區", "烏當區", "白雲區", "小河區", "清鎮市", "開陽縣", "修文縣", "息烽縣", "其他"]
    }, {
        "name": "六盤水",
        "area": ["鐘山區", "水城縣", "盤縣", "六枝特區", "其他"]
    }, {
        "name": "遵義",
        "area": ["紅花崗區", "匯川區", "赤水市", "仁懷市", "遵義縣", "綏陽縣", "桐梓縣", "習水縣", "鳳岡縣", "正安縣", "餘慶縣", "湄潭縣", "道真仡佬族苗族自治縣", "務川仡佬族苗族自治縣", "其他"]
    }, {
        "name": "安順",
        "area": ["西秀區", "普定縣", "平壩縣", "鎮寧布依族苗族自治縣", "紫雲苗族布依族自治縣", "關嶺布依族苗族自治縣", "其他"]
    }, {
        "name": "銅仁地區",
        "area": ["銅仁市", "德江縣", "江口縣", "思南縣", "石阡縣", "玉屏侗族自治縣", "松桃苗族自治縣", "印江土家族苗族自治縣", "沿河土家族自治縣", "萬山特區", "其他"]
    }, {
        "name": "畢節地區",
        "area": ["畢節市", "黔西縣", "大方縣", "織金縣", "金沙縣", "赫章縣", "納雍縣", "威寧彝族回族苗族自治縣", "其他"]
    }, {
        "name": "黔西南布依族苗族自治州",
        "area": ["興義市", "望謨縣", "興仁縣", "普安縣", "冊亨縣", "晴隆縣", "貞豐縣", "安龍縣", "其他"]
    }, {
        "name": "黔東南苗族侗族自治州",
        "area": ["凱裏市", "施秉縣", "從江縣", "錦屏縣", "鎮遠縣", "麻江縣", "臺江縣", "天柱縣", "黃平縣", "榕江縣", "劍河縣", "三穗縣", "雷山縣", "黎平縣", "岑鞏縣", "丹寨縣", "其他"]
    }, {
        "name": "黔南布依族苗族自治州",
        "area": ["都勻市", "福泉市", "貴定縣", "惠水縣", "羅甸縣", "甕安縣", "荔波縣", "龍裏縣", "平塘縣", "長順縣", "獨山縣", "三都水族自治縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "雲南",
    "city": [{
        "name": "昆明",
        "area": ["盤龍區", "五華區", "官渡區", "西山區", "東川區", "安寧市", "呈貢縣", "晉寧縣", "富民縣", "宜良縣", "嵩明縣", "石林彝族自治縣", "祿勸彝族苗族自治縣", "尋甸回族彝族自治縣", "其他"]
    }, {
        "name": "曲靖",
        "area": ["麒麟區", "宣威市", "馬龍縣", "沾益縣", "富源縣", "羅平縣", "師宗縣", "陸良縣", "會澤縣", "其他"]
    }, {
        "name": "玉溪",
        "area": ["紅塔區", "江川縣", "澄江縣", "通海縣", "華寧縣", "易門縣", "峨山彝族自治縣", "新平彝族傣族自治縣", "元江哈尼族彝族傣族自治縣", "其他"]
    }, {
        "name": "保山",
        "area": ["隆陽區", "施甸縣", "騰沖縣", "龍陵縣", "昌寧縣", "其他"]
    }, {
        "name": "昭通",
        "area": ["昭陽區", "魯甸縣", "巧家縣", "鹽津縣", "大關縣", "永善縣", "綏江縣", "鎮雄縣", "彝良縣", "威信縣", "水富縣", "其他"]
    }, {
        "name": "麗江",
        "area": ["古城區", "永勝縣", "華坪縣", "玉龍納西族自治縣", "寧蒗彝族自治縣", "其他"]
    }, {
        "name": "普洱",
        "area": ["思茅區", "普洱哈尼族彝族自治縣", "墨江哈尼族自治縣", "景東彝族自治縣", "景穀傣族彝族自治縣", "鎮沅彝族哈尼族拉祜族自治縣", "江城哈尼族彝族自治縣", "孟連傣族拉祜族佤族自治縣", "瀾滄拉祜族自治縣", "西盟佤族自治縣", "其他"]
    }, {
        "name": "臨滄",
        "area": ["臨翔區", "鳳慶縣", "雲縣", "永德縣", "鎮康縣", "雙江拉祜族佤族布朗族傣族自治縣", "耿馬傣族佤族自治縣", "滄源佤族自治縣", "其他"]
    }, {
        "name": "德宏傣族景頗族自治州",
        "area": ["潞西市", "瑞麗市", "梁河縣", "盈江縣", "隴川縣", "其他"]
    }, {
        "name": "怒江傈僳族自治州",
        "area": ["瀘水縣", "福貢縣", "貢山獨龍族怒族自治縣", "蘭坪白族普米族自治縣", "其他"]
    }, {
        "name": "迪慶藏族自治州",
        "area": ["香格里拉縣", "德欽縣", "維西傈僳族自治縣", "其他"]
    }, {
        "name": "大理白族自治州",
        "area": ["大理市", "祥雲縣", "賓川縣", "彌渡縣", "永平縣", "雲龍縣", "洱源縣", "劍川縣", "鶴慶縣", "漾濞彝族自治縣", "南澗彝族自治縣", "巍山彝族回族自治縣", "其他"]
    }, {
        "name": "楚雄彝族自治州",
        "area": ["楚雄市", "雙柏縣", "牟定縣", "南華縣", "姚安縣", "大姚縣", "永仁縣", "元謀縣", "武定縣", "祿豐縣", "其他"]
    }, {
        "name": "紅河哈尼族彝族自治州",
        "area": ["蒙自縣", "個舊市", "開遠市", "綠春縣", "建水縣", "石屏縣", "彌勒縣", "瀘西縣", "元陽縣", "紅河縣", "金平苗族瑤族傣族自治縣", "河口瑤族自治縣", "屏邊苗族自治縣", "其他"]
    }, {
        "name": "文山壯族苗族自治州",
        "area": ["文山縣", "硯山縣", "西疇縣", "麻栗坡縣", "馬關縣", "丘北縣", "廣南縣", "富寧縣", "其他"]
    }, {
        "name": "西雙版納傣族自治州",
        "area": ["景洪市", "勐海縣", "勐臘縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "西藏",
    "city": [{
        "name": "拉薩",
        "area": ["城關區", "林周縣", "當雄縣", "尼木縣", "曲水縣", "堆龍德慶縣", "達孜縣", "墨竹工卡縣", "其他"]
    }, {
        "name": "那曲地區",
        "area": ["那曲縣", "嘉黎縣", "比如縣", "聶榮縣", "安多縣", "申紮縣", "索縣", "班戈縣", "巴青縣", "尼瑪縣", "其他"]
    }, {
        "name": "昌都地區",
        "area": ["昌都縣", "江達縣", "貢覺縣", "類烏齊縣", "丁青縣", "察雅縣", "八宿縣", "左貢縣", "芒康縣", "洛隆縣", "邊壩縣", "其他"]
    }, {
        "name": "林芝地區",
        "area": ["林芝縣", "工布江達縣", "米林縣", "墨脫縣", "波密縣", "察隅縣", "朗縣", "其他"]
    }, {
        "name": "山南地區",
        "area": ["乃東縣", "紮囊縣", "貢嘎縣", "桑日縣", "瓊結縣", "曲松縣", "措美縣", "洛紮縣", "加查縣", "隆子縣", "錯那縣", "浪卡子縣", "其他"]
    }, {
        "name": "日喀則地區",
        "area": ["日喀則市", "南木林縣", "江孜縣", "定日縣", "薩迦縣", "拉孜縣", "昂仁縣", "謝通門縣", "白朗縣", "仁布縣", "康馬縣", "定結縣", "仲巴縣", "亞東縣", "吉隆縣", "聶拉木縣", "薩嘎縣", "崗巴縣", "其他"]
    }, {
        "name": "阿裏地區",
        "area": ["噶爾縣", "普蘭縣", "劄達縣", "日土縣", "革吉縣", "改則縣", "措勤縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "陝西",
    "city": [{
        "name": "西安",
        "area": ["蓮湖區", "新城區", "碑林區", "雁塔區", "灞橋區", "未央區", "閻良區", "臨潼區", "長安區", "高陵縣", "藍田縣", "戶縣", "周至縣", "其他"]
    }, {
        "name": "銅川",
        "area": ["耀州區", "王益區", "印臺區", "宜君縣", "其他"]
    }, {
        "name": "寶雞",
        "area": ["渭濱區", "金臺區", "陳倉區", "岐山縣", "鳳翔縣", "隴縣", "太白縣", "麟遊縣", "扶風縣", "千陽縣", "眉縣", "鳳縣", "其他"]
    }, {
        "name": "咸陽",
        "area": ["秦都區", "渭城區", "楊陵區", "興平市", "禮泉縣", "涇陽縣", "永壽縣", "三原縣", "彬縣", "旬邑縣", "長武縣", "乾縣", "武功縣", "淳化縣", "其他"]
    }, {
        "name": "渭南",
        "area": ["臨渭區", "韓城市", "華陰市", "蒲城縣", "潼關縣", "白水縣", "澄城縣", "華縣", "合陽縣", "富平縣", "大荔縣", "其他"]
    }, {
        "name": "延安",
        "area": ["寶塔區", "安塞縣", "洛川縣", "子長縣", "黃陵縣", "延川縣", "富縣", "延長縣", "甘泉縣", "宜川縣", "志丹縣", "黃龍縣", "吳起縣", "其他"]
    }, {
        "name": "漢中",
        "area": ["漢臺區", "留壩縣", "鎮巴縣", "城固縣", "南鄭縣", "洋縣", "寧強縣", "佛坪縣", "勉縣", "西鄉縣", "略陽縣", "其他"]
    }, {
        "name": "榆林",
        "area": ["榆陽區", "清澗縣", "綏德縣", "神木縣", "佳縣", "府穀縣", "子洲縣", "靖邊縣", "橫山縣", "米脂縣", "吳堡縣", "定邊縣", "其他"]
    }, {
        "name": "安康",
        "area": ["漢濱區", "紫陽縣", "嵐皋縣", "旬陽縣", "鎮坪縣", "平利縣", "石泉縣", "寧陝縣", "白河縣", "漢陰縣", "其他"]
    }, {
        "name": "商洛",
        "area": ["商州區", "鎮安縣", "山陽縣", "洛南縣", "商南縣", "丹鳳縣", "柞水縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "甘肅",
    "city": [{
        "name": "蘭州",
        "area": ["城關區", "七裏河區", "西固區", "安寧區", "紅古區", "永登縣", "皋蘭縣", "榆中縣", "其他"]
    }, {
        "name": "嘉峪關",
        "area": ["嘉峪關市", "其他"]
    }, {
        "name": "金昌",
        "area": ["金川區", "永昌縣", "其他"]
    }, {
        "name": "白銀",
        "area": ["白銀區", "平川區", "靖遠縣", "會寧縣", "景泰縣", "其他"]
    }, {
        "name": "天水",
        "area": ["清水縣", "秦安縣", "甘穀縣", "武山縣", "張家川回族自治縣", "北道區", "秦城區", "其他"]
    }, {
        "name": "武威",
        "area": ["涼州區", "民勤縣", "古浪縣", "天祝藏族自治縣", "其他"]
    }, {
        "name": "酒泉",
        "area": ["肅州區", "玉門市", "敦煌市", "金塔縣", "肅北蒙古族自治縣", "阿克塞哈薩克族自治縣", "安西縣", "其他"]
    }, {
        "name": "張掖",
        "area": ["甘州區", "民樂縣", "臨澤縣", "高臺縣", "山丹縣", "肅南裕固族自治縣", "其他"]
    }, {
        "name": "慶陽",
        "area": ["西峰區", "慶城縣", "環縣", "華池縣", "合水縣", "正寧縣", "寧縣", "鎮原縣", "其他"]
    }, {
        "name": "平涼",
        "area": ["崆峒區", "涇川縣", "靈臺縣", "崇信縣", "華亭縣", "莊浪縣", "靜寧縣", "其他"]
    }, {
        "name": "定西",
        "area": ["安定區", "通渭縣", "臨洮縣", "漳縣", "岷縣", "渭源縣", "隴西縣", "其他"]
    }, {
        "name": "隴南",
        "area": ["武都區", "成縣", "宕昌縣", "康縣", "文縣", "西和縣", "禮縣", "兩當縣", "徽縣", "其他"]
    }, {
        "name": "臨夏回族自治州",
        "area": ["臨夏市", "臨夏縣", "康樂縣", "永靖縣", "廣河縣", "和政縣", "東鄉族自治縣", "積石山保安族東鄉族撒拉族自治縣", "其他"]
    }, {
        "name": "甘南藏族自治州",
        "area": ["合作市", "臨潭縣", "卓尼縣", "舟曲縣", "迭部縣", "瑪曲縣", "碌曲縣", "夏河縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "青海",
    "city": [{
        "name": "西寧",
        "area": ["城中區", "城東區", "城西區", "城北區", "湟源縣", "湟中縣", "大通回族土族自治縣", "其他"]
    }, {
        "name": "海東地區",
        "area": ["平安縣", "樂都縣", "民和回族土族自治縣", "互助土族自治縣", "化隆回族自治縣", "循化撒拉族自治縣", "其他"]
    }, {
        "name": "海北藏族自治州",
        "area": ["海晏縣", "祁連縣", "剛察縣", "門源回族自治縣", "其他"]
    }, {
        "name": "海南藏族自治州",
        "area": ["共和縣", "同德縣", "貴德縣", "興海縣", "貴南縣", "其他"]
    }, {
        "name": "黃南藏族自治州",
        "area": ["同仁縣", "尖紮縣", "澤庫縣", "河南蒙古族自治縣", "其他"]
    }, {
        "name": "果洛藏族自治州",
        "area": ["瑪沁縣", "班瑪縣", "甘德縣", "達日縣", "久治縣", "瑪多縣", "其他"]
    }, {
        "name": "玉樹藏族自治州",
        "area": ["玉樹縣", "雜多縣", "稱多縣", "治多縣", "囊謙縣", "曲麻萊縣", "其他"]
    }, {
        "name": "海西蒙古族藏族自治州",
        "area": ["德令哈市", "格爾木市", "烏蘭縣", "都蘭縣", "天峻縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "寧夏",
    "city": [{
        "name": "銀川",
        "area": ["興慶區", "西夏區", "金鳳區", "靈武市", "永寧縣", "賀蘭縣", "其他"]
    }, {
        "name": "石嘴山",
        "area": ["大武口區", "惠農區", "平羅縣", "其他"]
    }, {
        "name": "吳忠",
        "area": ["利通區", "青銅峽市", "鹽池縣", "同心縣", "其他"]
    }, {
        "name": "固原",
        "area": ["原州區", "西吉縣", "隆德縣", "涇源縣", "彭陽縣", "其他"]
    }, {
        "name": "中衛",
        "area": ["沙坡頭區", "中寧縣", "海原縣", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "新疆",
    "city": [{
        "name": "烏魯木齊",
        "area": ["天山區", "沙依巴克區", "新市區", "水磨溝區", "頭屯河區", "達阪城區", "東山區", "烏魯木齊縣", "其他"]
    }, {
        "name": "克拉瑪依",
        "area": ["克拉瑪依區", "獨山子區", "白堿灘區", "烏爾禾區", "其他"]
    }, {
        "name": "吐魯番地區",
        "area": ["吐魯番市", "托克遜縣", "鄯善縣", "其他"]
    }, {
        "name": "哈密地區",
        "area": ["哈密市", "伊吾縣", "巴裏坤哈薩克自治縣", "其他"]
    }, {
        "name": "和田地區",
        "area": ["和田市", "和田縣", "洛浦縣", "民豐縣", "皮山縣", "策勒縣", "於田縣", "墨玉縣", "其他"]
    }, {
        "name": "阿克蘇地區",
        "area": ["阿克蘇市", "溫宿縣", "沙雅縣", "拜城縣", "阿瓦提縣", "庫車縣", "柯坪縣", "新和縣", "烏什縣", "其他"]
    }, {
        "name": "喀什地區",
        "area": ["喀什市", "巴楚縣", "澤普縣", "伽師縣", "葉城縣", "嶽普湖縣", "疏勒縣", "麥蓋提縣", "英吉沙縣", "莎車縣", "疏附縣", "塔什庫爾幹塔吉克自治縣", "其他"]
    }, {
        "name": "克孜勒蘇柯爾克孜自治州",
        "area": ["阿圖什市", "阿合奇縣", "烏恰縣", "阿克陶縣", "其他"]
    }, {
        "name": "巴音郭楞蒙古自治州",
        "area": ["庫爾勒市", "和靜縣", "尉犁縣", "和碩縣", "且末縣", "博湖縣", "輪臺縣", "若羌縣", "焉耆回族自治縣", "其他"]
    }, {
        "name": "昌吉回族自治州",
        "area": ["昌吉市", "阜康市", "奇臺縣", "瑪納斯縣", "吉木薩爾縣", "呼圖壁縣", "木壘哈薩克自治縣", "米泉市", "其他"]
    }, {
        "name": "博爾塔拉蒙古自治州",
        "area": ["博樂市", "精河縣", "溫泉縣", "其他"]
    }, {
        "name": "石河子",
        "area": ["石河子"]
    }, {
        "name": "阿拉爾",
        "area": ["阿拉爾"]
    }, {
        "name": "圖木舒克",
        "area": ["圖木舒克"]
    }, {
        "name": "五家渠",
        "area": ["五家渠"]
    }, {
        "name": "伊犁哈薩克自治州",
        "area": ["伊寧市", "奎屯市", "伊寧縣", "特克斯縣", "尼勒克縣", "昭蘇縣", "新源縣", "霍城縣", "鞏留縣", "察布查爾錫伯自治縣", "塔城地區", "阿勒泰地區", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "臺灣",
    "city": [{
        "name": "臺灣",
        "area": ["臺北市", "高雄市", "臺北縣", "桃園縣", "新竹縣", "苗栗縣", "臺中縣", "彰化縣", "南投縣", "雲林縣", "嘉義縣", "臺南縣", "高雄縣", "屏東縣", "宜蘭縣", "花蓮縣", "臺東縣", "澎湖縣", "基隆市", "新竹市", "臺中市", "嘉義市", "臺南市", "其他"]
    }, {
        "name": "其他",
        "area": ["其他"]
    }]
}, {
    "name": "澳門",
    "city": [{
        "name": "澳門",
        "area": ["花地瑪堂區", "聖安多尼堂區", "大堂區", "望德堂區", "風順堂區", "嘉模堂區", "聖方濟各堂區", "路氹", "其他"]
    }]
}, {
    "name": "香港",
    "city": [{
        "name": "香港",
        "area": ["中西區", "灣仔區", "東區", "南區", "深水埗區", "油尖旺區", "九龍城區", "黃大仙區", "觀塘區", "北區", "大埔區", "沙田區", "西貢區", "元朗區", "屯門區", "荃灣區", "葵青區", "離島區", "其他"]
    }]
}];
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/bee-city-select/build/citys-tw.js
// module id = 633
// module chunks = 0